









import Vue, { PropType } from 'vue';
import { Icon } from '../../../basic';

export default Vue.extend({
  name: 'FilterItem',
  components: {
    Icon,
  },
  props: {
    removeItem: Function,
  },
});
